import React from 'react'
import {t} from "i18next";

const NotAuthorized = () => {
  return (
        <div className="main-container-body" style={{ display:'flex',justifyContent:'center',alignItems:'center',fontSize:'30px' }}>
        <span style={{color:"#a94442"}}>{t("label.error-header")}</span>
        <span style={{padding:"10px 20px", textAlign:'center', lineHeight:"45px"}}>You're not authorized to access the requested page.</span>
      </div>
  )
}

export default NotAuthorized